import {FormStatus} from '../enums/file-status.enum';

export class FormState {
    model: any;
    dirty = false;
    status: FormStatus = FormStatus.INIT;
    errors: any = {};
    validationErrors: any = {};

    constructor(props = {}) {
        Object.assign(this, props);
    }

    get isInvalid() {
        return this.status.toString() === FormStatus.INVALID.toString();
    }

    get isSuccessful() {
        return this.status.toString() === FormStatus.SUCCESS.toString();
    }
}
